export default __webpack_public_path__ + "static/media/Leave-Button.4783adcd.svg";